export default __webpack_public_path__ + "static/media/villa_10.d0954920.jpg";